import { render } from "./InputField.vue?vue&type=template&id=38797f60"
import script from "./InputField.vue?vue&type=script&lang=js"
export * from "./InputField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__